import { useQuery } from '@tanstack/react-query';

import getGiveawaySessions from 'Api/productivity-host/getGiveawaySessions';
import getGiveawaySessionsResponse from './model/response/getGiveawaySessionsResponse';

const useGetGiveawaySessions = (isLivestreaming) => {
  return useQuery({
    queryKey: ['giveaway-sessions'],
    queryFn: async () => {
      const response = await getGiveawaySessions();

      return getGiveawaySessionsResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: isLivestreaming,
  });
};

export default useGetGiveawaySessions;
